import React from 'react';
import T from 'mrf/utils/T';
import { StyledFooter, StyledImageLeft, StyledImageRight } from 'styles/components/Footer.styles';

export default function Footer() {
    return (
        <StyledFooter>
            <StyledImageLeft>
                <img src="/OEA_OAS.gif" alt="OEA/OAS" />
            </StyledImageLeft>
            <T>MCTA</T>
            <StyledImageRight>
                <img src="/EU.svg" alt="EU"/>
            </StyledImageRight>
        </StyledFooter>
    );
}
